import LocalizedStrings from 'react-localization';
import { strings as en } from './en/all';
import { strings as tr } from './tr/all';

let lang_strings = new LocalizedStrings({
  en,
  tr,
});

export const strings = lang_strings;
